import React from 'react';
import { strings } from '../../../resources/strings';
import {
  IFilterToListPendingInvoicingOrdersOutput,
  deliveryOptions,
  situationOptions,
  sortOptions,
  stateOptions
} from '../ModalFiltersToListPendingInvoicingOrders/ModalFiltersToListPendingInvoicingOrders';
import { Container, Filter, FilterName, FilterValue, Title, Filters } from './styles';

interface IFiltersProps {
  appliedFilters?: IFilterToListPendingInvoicingOrdersOutput;
  marginTop?: string;
}

const AppliedFiltersToListPendingInvoicingOrders: React.FC<IFiltersProps> = ({
  appliedFilters,
  marginTop
}) => {

  const renderFilter = (name: string, value?: string | null) => {
    if (!value) return null;

    return (
      <Filter>
        <FilterName>{name}: </FilterName>
        <FilterValue>{value}</FilterValue>
      </Filter>
    );
  }

  const getText = (options: { key: string, text: string }[], key?: string) =>
    options.find(option => option.key === key)?.text;

  // a situação sempre tem valor (padrão Pendentes); entrega "Todas" e a ordem padrão não são exibidas
  const deliveryText = appliedFilters?.delivery && appliedFilters.delivery !== deliveryOptions[0].key
    ? getText(deliveryOptions, appliedFilters.delivery)
    : undefined;
  const sortText = appliedFilters?.sort && appliedFilters.sort !== sortOptions[0].key
    ? getText(sortOptions, appliedFilters.sort)
    : undefined;

  return (
    <Container marginTop={marginTop}>
      <Title>{strings.AppliedFilters}</Title>
      <Filters>
        {renderFilter('Pedido', appliedFilters?.number)}
        {renderFilter('Situação', getText(situationOptions, appliedFilters?.situation))}
        {renderFilter('Estado', appliedFilters?.stateId ? getText(stateOptions, `${appliedFilters.stateId}`) : undefined)}
        {renderFilter('Entrega', deliveryText)}
        {renderFilter('Ordem', sortText)}
      </Filters>
    </Container>
  );
}

export { AppliedFiltersToListPendingInvoicingOrders };